module.exports = __webpack_public_path__ + "img/cegep-sorel-tracy.aaf188a0.webp";